import useStyles from './styles';
import clsx from 'clsx';
interface IStepDot {
  prevDot: number;
  selectDot: number;
  totalDot: number;
  withoutLine?: boolean;
  customClass?: string;
}

const StepDot = (props: IStepDot) => {
  const styles = useStyles();
  const { selectDot, totalDot, prevDot, withoutLine, customClass } = props;

  const getClassAnimation = (i: number) => {
    if (i === selectDot) {
      return styles.dot_zoom_in;
    } else if (i === prevDot && prevDot < selectDot) {
      return styles.dot_zoom_out_purple;
    } else if (i === prevDot && prevDot > selectDot) {
      return styles.dot_zoom_out_grey;
    }
    return '';
  };

  const renderListDot = () => {
    let listDot = [];
    for (let i = 0; i < totalDot; i++) {
      listDot.push(
        <div className={styles.viewDot} key={i}>
          <div className={`${styles.dot} ${getClassAnimation(i)} ${i < selectDot && styles.dotPurple}`}></div>
          {!withoutLine && i < totalDot - 1 ? (
            <div className={styles.line} />
          ) : null}
        </div>
      );
    }
    return listDot;
  };

  return (
    <div className={clsx(styles.container, customClass)}>{renderListDot()}</div>
  );
};

export default StepDot;
